import { Client, UserClaims } from '.';
import { defineMessages, FormattedMessage, MessageDescriptor } from 'react-intl';

const m = defineMessages({
    accountTypeRequired: { id: 'User.account_type_required', defaultMessage: 'The account type is required.' },
    emailRequired: { id: 'User.email_required', defaultMessage: 'The user\'s email address is required.' },
    emailInvalid: { id: 'User.email_invalid', defaultMessage: 'Please enter a valid email address for the user.' },
    passwordRequired: { id: 'User.password_required', defaultMessage: 'The password is required.' },
    passwordLengthInvalid: { id: 'User.password_invalid_length', defaultMessage: 'The password does not contain at least 8 characters.' },
    passwordNonAlphaNumericInvalid: { id: 'User.password_invalid_nonalphanumeric', defaultMessage: 'The password does not contain at least one non alphanumeric character.' },
    passwordConfirmationRequired: { id: 'User.password_confirmation_required', defaultMessage: 'The password confirmation is required.' },
    passwordConfirmationMismatch: { id: 'User.password_confirmation_mismatch', defaultMessage: 'The password and password confirmation does not match.' },
});

export interface User {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    accountType: UserAccountType;
    isDisabled: boolean;
    claims: UserClaims;
}

export enum UserAccountType {
    none,
    client,
    customerServiceAgent,
    administrator,
    jaymarRepresentative,
    jaymarTechnician,
    factoryTechnician
}

export const authenticatedUsers: UserAccountType[] = [
    UserAccountType.administrator,
    UserAccountType.client,
    UserAccountType.customerServiceAgent,
    UserAccountType.jaymarRepresentative,
    UserAccountType.jaymarTechnician,
    UserAccountType.factoryTechnician
];

export const technicians: UserAccountType[] = [
    UserAccountType.administrator,
    UserAccountType.jaymarTechnician
];

export const agents: UserAccountType[] = [
    UserAccountType.administrator,
    UserAccountType.customerServiceAgent
];

export const employees: UserAccountType[] = [
    UserAccountType.administrator,
    UserAccountType.customerServiceAgent,
    UserAccountType.jaymarRepresentative,
    UserAccountType.jaymarTechnician,
    UserAccountType.factoryTechnician
];

export const factoryTechnicians: UserAccountType[] = [
    UserAccountType.administrator,
    UserAccountType.factoryTechnician
];

export const representatives: UserAccountType[] = [
    UserAccountType.jaymarRepresentative
];